var map = {
	"./featured-banner.de-CH.json": 1080,
	"./featured-banner.de-DE.json": 1081,
	"./featured-banner.en-CA.json": 1082,
	"./featured-banner.en-GB.json": 1083,
	"./featured-banner.en-IN.json": 1084,
	"./featured-banner.en-ME.json": 1085,
	"./featured-banner.en-US.json": 1086,
	"./featured-banner.es-EM.json": 1087,
	"./featured-banner.es-ES.json": 1088,
	"./featured-banner.fr-BE.json": 1089,
	"./featured-banner.fr-CA.json": 1090,
	"./featured-banner.fr-CH.json": 1091,
	"./featured-banner.nl-BE.json": 1092,
	"./featured-banner.nl-NL.json": 1093,
	"./featured-banner.pl-PL.json": 1094,
	"./featured-banner.pt-BR.json": 1095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1079;